export default __webpack_public_path__ + "static/session-formula-light-mode-914d8ea53d3f035d179be98eb2db3649.png";